module.exports = __webpack_public_path__ + "static/media/contadinoWhite.60d4bc7f.png";